@if (error) {
  <div class="error-container">
    <h1>Error Occurred</h1>
    <h2>Status Code: {{error.status}}</h2>
    <p>{{ error.message }}</p>
    <p>Please try again, or you can <a routerLink="/crypt">return to the home page</a>. </p>
  </div>
}
